import { useCallback, useEffect, useState } from 'react'
import Divider from '@mui/material/Divider'
import Grid from '@mui/material/Grid'
import * as api from '../../../services/api'
import { ApiProps, ListAllApiProps } from '../../../types/api'
import { CompanyApiFailureMessageProps, FailureRule, ListCompanyApiFailureMessageProps } from '../../../types/companyApiFailureMessage'
import AddFailureMessageForm from './AddFailureMessageForm'
import FailureMessageList from './FailureMessageList'

type FailureMessagesSectionProps = {
  companyId: string
}

export default function FailureMessagesSection({ companyId }: FailureMessagesSectionProps): JSX.Element {
  const [failureMessages, setFailureMessages] = useState<CompanyApiFailureMessageProps[]>([])
  const [apiOptions, setApiOptions] = useState<ApiProps[]>([])

  const getFailureMessages = useCallback(async () => {
    const response = await api.get(`company/api-failure-message/list/?company=${companyId}`) as ListCompanyApiFailureMessageProps
    setFailureMessages(response.content.results)
  }, [companyId])

  const getApiOptions = useCallback(async () => {
    const response = await api.get('api/list/all/') as ListAllApiProps
    setApiOptions(response.content)
  }, [])

  useEffect(() => {
    getFailureMessages().catch(console.error)
    getApiOptions().catch(console.error)
  }, [getFailureMessages, getApiOptions])

  function updateFailureMessageRules(itemId: string, rules: FailureRule[]) {
    setFailureMessages(prev => prev.map((item) => item.id === itemId ? { ...item, rules } : item))
  }

  function removeFailureMessage(itemId: string) {
    setFailureMessages(prev => prev.filter((item) => item.id !== itemId))
  }

  return (
    <>
      <Divider sx={{ marginY: 5 }} />
      <Grid container spacing={2}>
        <Grid item md={12} xs={12}>
          <h3>Mensagens de erro por API</h3>
        </Grid>
      </Grid>

      <Grid container spacing={4}>
        <Grid item md={12} xs={12}>
          <AddFailureMessageForm
            companyId={companyId}
            apiOptions={apiOptions}
            existingApiIds={failureMessages.map((item) => item.api)}
            onCreated={getFailureMessages}
          />
        </Grid>

        <Grid item md={12} xs={12}>
          <FailureMessageList
            items={failureMessages}
            onRulesChange={updateFailureMessageRules}
            onDeleted={removeFailureMessage}
          />
        </Grid>
      </Grid>
    </>
  )
}
